"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CoachingDaysAdapter_1 = __importDefault(require("./CoachingDaysAdapter"));
const NumberOfCoachingDays_1 = __importDefault(require("./NumberOfCoachingDays"));
const PeriodToSubscriptionReducer_1 = __importDefault(require("./PeriodToSubscriptionReducer"));
// TODO: Verify that file and check if we can default values to 0
const sortPeriods = (a, b) => {
    const startTimeA = new Date((a === null || a === void 0 ? void 0 : a.start) || 0).getTime();
    const startTimeB = new Date((b === null || b === void 0 ? void 0 : b.start) || 0).getTime();
    return startTimeA - startTimeB;
};
exports.default = (periods) => {
    const uniqueSubscriptionsId = Array.from(new Set(periods.map((p) => p.subscriptionId)));
    return uniqueSubscriptionsId.map((id) => {
        const preparedPeriods = periods
            .filter((p) => p.subscriptionId === id)
            .sort(sortPeriods);
        return preparedPeriods
            .map((period) => {
            var _a;
            // @ts-ignore
            return {
                ...period,
                coachingDays: period.model && period.coachingDays
                    ? (0, CoachingDaysAdapter_1.default)(period.model, period.coachingDays)
                    : null,
                subscriptionType: Boolean(period.model)
                    ? {
                        typeId: period.model,
                        numberOfCoachingDays: period.model
                            ? (0, NumberOfCoachingDays_1.default)(period.model)
                            : 0,
                    }
                    : null,
                trainingLocation: period.trainingLocation,
                coach: period.coach,
                duration: period.duration,
                end: period.end,
                start: period.start,
                plan: period.plan,
                subscriptionId: (_a = period.subscriptionId) === null || _a === void 0 ? void 0 : _a.toString(),
            };
        })
            .reduce(PeriodToSubscriptionReducer_1.default);
    });
};
//# sourceMappingURL=RawPeriodsToSubscriptionAdapter.js.map